<template>
	<div>
		<Table :recordset="recordsetItems" :columns="locationsColumns">
			<template v-slot:activeCheckbox="slotProps">
				<Checkbox
					:value="slotProps.record.active"
					@change="onClickActive(slotProps.record.id)"
				/>
			</template>
			<template v-slot:deleteAction="slotProps">
				<ButtonIcon
					iconClassName="icon-remove"
					@click="onRemoveLocation(slotProps.record.id)"
				/>
			</template>
		</Table>
		<ButtonClassic labelText="Add New Location" @click="onAddNewLocation" />
		<Modal
			:visible="modalVisible"
			:title="modalTitle"
			:clickClose="onModalClose"
		>
			<template v-slot:body>
				<CompanyLocationAdd />
			</template>
		</Modal>
	</div>
</template>

<script>
import Table from '@/components/shells/table/table.vue';
import locationsColumns from './company-locations-columns';
import { mapGetters, mapActions } from 'vuex';
import viewMixin from '@/mixins/view-mixin';
import ButtonIcon from '@/components/forms/button/button-icon.vue';
import Checkbox from '@/components/forms/selection-control/checkbox/checkbox.vue';
import ButtonClassic from '@/components/forms/button/button-classic.vue';
import Modal from '@/components/shells/modal/modal.vue';
import CompanyLocationAdd from './company-location-add-view.vue';

export default {
	name: 'CompanyLocations',
	mixins: [viewMixin],
	components: {
		Table,
		ButtonIcon,
		Checkbox,
		ButtonClassic,
		Modal,
		CompanyLocationAdd
	},
	data() {
		return {
			modalTitle: 'Add Location',
			modalVisible: false
		};
	},
	created() {
		this.load();
	},
	computed: {
		...mapGetters('defaultSettings', ['locationsResults']),
		locationsColumns() {
			return locationsColumns;
		},
		recordsetItems() {
			return this.locationsResults(this.companyId).items;
		}
	},
	methods: {
		...mapActions('defaultSettings', ['getLocationsAction']),
		async load() {
			await this.getLocationsAction(this.companyId);

			this.$emit('locationsLoaded');
		},
		onRemoveLocation(id) {
			console.log(`onRemoveLocation ${id}`);
		},
		onClickActive(id) {
			console.log(`onClickActive ${id}`);
		},
		onAddNewLocation() {
			this.modalVisible = true;
		},
		onModalClose() {
			this.modalVisible = false;
		}
	}
};
</script>

<style lang="scss" scoped></style>
